/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Account_Status_LockedInputs */

const vi_shop_account_status_locked = /** @type {(inputs: Shop_Account_Status_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã khoá`)
};

/**

* @param {Shop_Account_Status_LockedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_account_status_locked = /** @type {((inputs?: Shop_Account_Status_LockedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Account_Status_LockedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_account_status_locked(inputs)
});